import Vue from "vue";
import Vuex from "vuex";
import ChromeStore from "./chromeStore";
import UserStore from "./userStore";
import ClientsStore from "./clientsStore";
import TestsStore from "./testsStore";
import KitsStore from "./kitsStore";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ChromeStore,
    UserStore,
    ClientsStore,
    TestsStore,
    KitsStore
  }
});
